export default import.meta.ROLLDOWN_FILE_URL_EycYD4MKA2_RHOkh0yIivA